/**
 * Recently Played Games Model
 */

define(function(require, exports, module) {
    'use strict';

    var BaseModel = require('common/base.model');

    module.exports = BaseModel.extend({
        parse: function(code) {
            return !code ? null : {
                code: code
            };
        }
    });
});